<template>
  <div id="login-view">
    <v-content>
      <v-container>
        <v-layout justify-center row wrap>
          <v-flex xs12 sm8 md6>
            <v-card
              max-width="800px"
              elevation=24
            >

              <v-toolbar dark color="primary">
                <v-layout justify-center>
                  <v-toolbar-title>{{ title }}</v-toolbar-title>
                </v-layout>
              </v-toolbar>

              <v-layout align-center justify-center row fill-height>
                <router-link to="/">
                  <v-img
                    :src="require('../assets/fuzzcv-logo.png')"
                    contain
                    alt="fuzzcv curriculum vitae CV automatique en ligne"
                    width="300"
                    class="mt-3">
                  </v-img>
                </router-link>
              </v-layout>
              <v-card-text class="subheading pt-5 pb-0">
                {{ explainText }}
              </v-card-text>

              <v-layout align-center justify-center row fill-height
                v-if="registrationLoading"
              >
                <v-progress-circular
                  :size="70"
                  :width="7"
                  indeterminate
                  color="primary"
                  class="text-xs-center mb-5"
                ></v-progress-circular>
              </v-layout>

              <v-form
                v-else-if="!registrationCompleted"
              >
                <v-card-text class="py-0">
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-text-field
                        name="email"
                        v-model="inputs.email"
                        :label="labelEmail"
                        required
                        prepend-icon="mail_outline"
                        v-validate="'email'"
                        data-vv-as="email"
                        :error-messages="errors.collect('email')"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        name="username"
                        v-model="inputs.username"
                        :label="labelUsername"
                        required
                        prepend-icon="person_outline"
                        v-validate="'max:25'"
                        data-vv-as="nom d'utilisateur"
                        :error-messages="errors.collect('username')"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        name="password1"
                        v-model="inputs.password1"
                        :label="labelPasswd"
                        type="password"
                        required
                        prepend-icon="lock"
                        ref="password1"
                        data-vv-as="premier mot de passe"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                        name="password2"
                        v-model="inputs.password2"
                        :label="labelPasswdConfirm"
                        type="password"
                        required
                        prepend-icon="lock"
                        v-validate="'required|confirmed:password1'"
                        data-vv-as="confirmation du mot de passe"
                        :error-messages="errors.collect('password2')"
                      >
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                </v-card-text>
                <v-card-actions>
                  <v-layout wrap>

                    <v-flex xs12>
                      <div class="mb-3">
                        <v-alert v-show="registrationError"
                          :value="true"
                          type="warning"
                          class="mb-2"
                        >
                        {{ registrationRaisonError }}
                        </v-alert>
                      </div>
                    </v-flex>

                    <v-layout align-center justify-space-between row wrap fill-height>
                      <v-btn color="info" @click="createAccount(inputs)">{{ buttonLabel }}</v-btn>
                      <small>{{ required_fields }}</small>
                      <v-flex xs12 pt-2>
                        {{ acceptCGU  }} <router-link to="/cgu" target="_blank">{{ linkCGU }}.</router-link>
                      </v-flex>
                    </v-layout>

                  </v-layout>
                </v-card-actions>
              </v-form>
              <v-card-text v-else>
                <v-flex xs12>
                  <div class="mt-3">
                    <v-alert
                      :value="true"
                      type="success"
                    >
                       {{ successMsg }}
                    </v-alert>
                    <div>
                      <router-link to="/login">{{ backToPageLabel }}</router-link>
                    </div>
                  </div>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </div>
</template>



<script>

import { mapActions, mapState } from 'vuex';

export default {
  beforeRouteLeave(to, from, next) {
    this.clearRegistrationStatus();
    next();
  },
  computed: mapState('signup', [
    'activationCompleted',
    'activationError',
    'activationLoading',
    'registrationCompleted',
    'registrationError',
    'registrationLoading',
    'registrationRaisonError',
  ]),
  data: function() {
    return {
      title: "Inscription",
      explainText: "Inscrivez-vous avec votre email.",
      labelEmail:'Email*',
      labelUsername: "nom d'utilisateur*",
      labelPasswd: "Mot de passe*",
      labelPasswdConfirm: "Confirmer mot de passe*",
      buttonLabel: "S'inscrire",
      successMsg: `Merci de vous être inscrit(e).
       Veuillez consultez votre boîte mail : un email d'activation vous a été envoyé.
       Si ce mail n'apparaît pas après quelques minutes, vérifier votre répertoire de spam.`,
      required_fields: `*Champs requis`,
      backToPageLabel: "Aller à la page de login.",
      inputs: {
        username: '',
        password1: '',
        password2: '',
        email: '',
      },
      acceptCGU: `En vous inscrivant, vous acceptez les `,
      linkCGU: "conditions d'utilisation",

    }
  },
  methods: {
    ...mapActions('signup', [
      'createAccount',
      'clearRegistrationStatus',
    ]),
  },
  created: function() {
    // permet de réinitialiser le status lorque que l'on tape
    // l'url directement ou en cas de refresh.
    this.clearRegistrationStatus();
  },

}
</script>

<style>

</style>
